import React from "react"
// import Link from "gatsby-plugin-transition-link/Link"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import "./soluciones.scss"

export const SolucionesBar = () => {
  return (
    <>
      <section
        className="soluciones-container"
        data-sal="slide-up"
        data-sal-easing="ease"
      >
        <h4 className="soluciones-title">Soluciones</h4>
        <div className="soluciones">
          <div className="soluciones-items-container text-center">
            <Link to="/soluciones/salas-multimedia" className="salas">
              <div className="soluciones-item salas">
                <StaticImage
                  src="../../../images/home/soluciones/SALAS MULTIMEDIA-NARANJA.svg"
                  alt="logo1"
                  class="soluciones-logo-salas"
                  placeholder="tracedSVG"
                />
                <h5>
                  Salas <br /> multimedia
                </h5>
              </div>
            </Link>
            <Link to="/soluciones/videoconferencia" className="video">
              <div className="soluciones-item video">
                <StaticImage
                  src="../../../images/home/soluciones/VIDEO-COMFERENCIA-AZUL.svg"
                  alt="logo2"
                  class="soluciones-logo-video"
                  placeholder="tracedSVG"
                />
                <h5>
                  Video <br /> conferencia
                </h5>
              </div>
            </Link>
            <Link to="/soluciones/automatizacion" className="settings">
              <div className="soluciones-item settings">
                <StaticImage
                  src="../../../images/home/soluciones/AUTOMATIZACIÓN-NARANJA.svg"
                  alt="logo3"
                  class="soluciones-logo-settings"
                  placeholder="tracedSVG"
                />
                <h5>Automatización</h5>
              </div>
            </Link>
            <Link to="/soluciones/videowall" className="display">
              <div className="soluciones-item display">
                <StaticImage
                  src="../../../images/home/soluciones/VIDEO-WALL-AZUL.svg"
                  alt="logo3"
                  class="soluciones-logo-display"
                  placeholder="tracedSVG"
                />
                <h5>
                  Video-wall <br /> Displays
                </h5>
              </div>
            </Link>
            <Link to="/soluciones/sonorizacion" className="speaker">
              <div className="soluciones-item speaker">
                <StaticImage
                  src="../../../images/home/soluciones/SINCRO AMBIENTE-NARANJA.svg"
                  alt="logo3"
                  class="soluciones-logo-speaker"
                  placeholder="tracedSVG"
                />
                <h5>
                  Sonorización <br /> de ambiente
                </h5>
              </div>
            </Link>
            <Link to="/soluciones/mobiliario" className="chair">
              <div className="soluciones-item chair">
                <StaticImage
                  src="../../../images/home/soluciones/AUDIO-AZUL.svg"
                  alt="logo3"
                  class="soluciones-logo-chair"
                  placeholder="tracedSVG"
                />
                <h5>Mobiliario</h5>
              </div>
            </Link>
            <Link to="/soluciones/proyectores" className="projector">
              <div className="soluciones-item projector">
                <StaticImage
                  src="../../../images/home/soluciones/PROYECTOR-NARANJA.svg"
                  alt="logo3"
                  class="soluciones-logo-projector"
                  placeholder="tracedSVG"
                />
                <h5>Proyectores</h5>
              </div>
            </Link>
            <div className="soluciones-item-btn">
              <h4>Conozca nuestros</h4>
              <Link className="soluciones-btn" to="/soporte/planes">
                <button className="soluciones-btn">planes de soporte</button>
              </Link>
            </div>
          </div>
        </div>
        <div className="soluciones-item-btn-mobile">
          <button>planes y soporte</button>
        </div>
      </section>
    </>
  )
}
